module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.ttf
// module chunks = styles